import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useCallback } from 'react';
import { DoubleArrowUpIcon } from '../../components/doubleArrowUpIcon';
import { EntryContactOptionsPanel } from '../../components/entryContactOptionsPanel';
import { DEFAULT_DARKER_BACKGROUND_COLOR, DEFAULT_DARKER_BACKGROUND_TEXT_COLOR } from '../../styles/colors';
import { DynamicEntryColumnContent } from './dynamicEntryColumnContent';
import { StaticEntryColumnContent } from './staticEntryColumnContent';
const CONTAINER_CSS = css `
  background-color: ${DEFAULT_DARKER_BACKGROUND_COLOR};
  color: ${DEFAULT_DARKER_BACKGROUND_TEXT_COLOR};
  width: 100%;
`;
const COLUMNS_CONTAINER_CSS = css `
  display: flex;
  flex-flow: row wrap;
  gap: 10px 120px;
  justify-content: center;
`;
const PaddedContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;
export const WelcomePanel = () => {
    const onClickPlay = useCallback(() => {
        const scrollTargetElement = document.querySelector('#top-scroll-target');
        if (scrollTargetElement) {
            scrollTargetElement.scrollIntoView({ behavior: 'smooth' });
        }
        const entryPanelElement = document.querySelector('#entry-panel');
        if (entryPanelElement) {
            // A bit hacky, define multiple identical CSS animations so they can be triggered
            // multiple times in a row (through alternating class name) and will be re-trigger the animation each time:
            if (entryPanelElement.classList.contains('glow-animation')) {
                entryPanelElement.classList.remove('glow-animation');
                entryPanelElement.classList.add('glow-animation2');
            }
            else if (entryPanelElement.classList.contains('glow-animation2')) {
                entryPanelElement.classList.remove('glow-animation2');
                entryPanelElement.classList.add('glow-animation');
            }
            else {
                entryPanelElement.classList.add('glow-animation');
            }
        }
    }, []);
    return (_jsxs("div", { css: CONTAINER_CSS, children: [_jsxs("div", { css: COLUMNS_CONTAINER_CSS, children: [_jsx(StaticEntryColumnContent, {}), _jsx(DynamicEntryColumnContent, {})] }), _jsxs(PaddedContainer, { children: [_jsx("div", { css: css `
            padding: 25px;
          `, children: _jsx(Button, { onClick: onClickPlay, variant: 'contained', endIcon: _jsx(DoubleArrowUpIcon, {}), size: 'large', children: "Play Now" }) }), _jsx(EntryContactOptionsPanel, {}), _jsxs(Typography, { variant: 'subtitle1', css: css `
            padding-top: 20px;
          `, children: ["Created by", ' ', _jsx("a", { href: 'https://www.scottbalay.com/', target: '_blank', rel: 'noreferrer', children: "ZenBlender" })] }), _jsxs(Typography, { variant: 'subtitle2', css: css `
            padding-top: 20px;
          `, children: ["*Triplejack is ", _jsx("em", { children: "not" }), " a real money poker site and is 100% legal. We are ", _jsx("em", { children: "not" }), " affiliated with real money gambling ventures and provide this game as a fun and casual alternative for those who want to play free poker."] })] })] }));
};
